export type ChangelogCategory = 'Feature' | 'Improvement' | 'Fix';

export interface ChangelogEntry {
  id: string;
  date: string;
  category: ChangelogCategory;
  title: string;
  body: string;
}

const categories: ChangelogCategory[] = ['Feature', 'Improvement', 'Fix'];
const maxChangelogEntries = 30;

const modules = import.meta.glob(['../../changelog/*.md', '!../../changelog/_*.md'], {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

function parseEntry(path: string, raw: string): ChangelogEntry {
  const id = path.split('/').pop()!.replace(/\.md$/, '');
  const match = /^---\s*\n([\s\S]*?)\n---\s*\n?([\s\S]*)$/.exec(raw.trim());

  const front: Record<string, string> = {};
  let body = raw.trim();

  if (match) {
    body = match[2].trim();
    for (const line of match[1].split('\n')) {
      const idx = line.indexOf(':');
      if (idx === -1) continue;
      front[line.slice(0, idx).trim()] = line.slice(idx + 1).trim();
    }
  }

  const category = categories.includes(front.category as ChangelogCategory)
    ? (front.category as ChangelogCategory)
    : 'Improvement';

  return {
    id,
    date: front.date ?? '',
    category,
    title: front.title ?? id,
    body,
  };
}

export const changelogEntries: ChangelogEntry[] = Object.entries(modules)
  .filter(([path]) => !path.split('/').pop()!.startsWith('_'))
  .map(([path, raw]) => parseEntry(path, raw))
  .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))
  .slice(0, maxChangelogEntries);

export const latestChangelogDate = changelogEntries[0]?.date ?? '';
